export const hasParentWithSelector = (element: Element, selector: string) => {
  let hasParentSelector = false;
  let parentElement = element.parentElement;

  while (parentElement && !hasParentSelector) {
    hasParentSelector = parentElement.matches(selector);
    parentElement = parentElement.parentElement;
  }

  return hasParentSelector;
};
